// ** React Imports
import { ChangeEvent } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import Typography from '@mui/material/Typography'

// ** Icons Imports
import React from 'mdi-material-ui/React'

// ** Custom Avatar Component
import CustomAvatar from 'src/@core/components/mui/avatar'

import { RootState } from 'src/store'
import { useSelector } from 'react-redux'

interface TabChannelTypeSelection {
    setChannelType: (arg0: number) => void
    channelType: number
    medium: number
}

const TabChannelTypeSelection = (props: TabChannelTypeSelection) => {
    const { channelType, setChannelType, medium } = props
    const store = useSelector((state: RootState) => state.lookup)

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateChanel(event.target.value);
    }

    const updateChanel = (name: string) => {
        let selectedChannelType = store.data.channelTypes.filter(p => p.name == name && p.mediumId == medium)[0];

        if (!selectedChannelType) return;
        setChannelType(selectedChannelType.id);
    }

    const isSelectedMedium = (name: string): boolean => {
        let selectedMedium = store.data.mediums.filter(p => p.name == name)[0];
        if (!selectedMedium) return false;
        return medium == selectedMedium.id;
    };

    const isSelectedChannelType = (name: string): boolean => {
        let selectedChannelType = store.data.channelTypes.filter(p => p.name == name && p.mediumId == medium)[0];
        if (!selectedChannelType) return false; 
        return channelType == selectedChannelType.id;
    };

    //TODO|SMMP Localize/Download Image assets, Make caption statements as constants

    return (
        <Box>
            <Typography variant='h6' sx={{ mb: 4 }}>
                Select Channel
            </Typography>
            <Box sx={{ mb: 8 }}>
                {isSelectedMedium("Facebook") &&
                    <>
                        <Box
                            onClick={() => updateChanel('Page')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/cotton/32/one-page.png" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Facebook Page</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                       Places on Facebook where artists, public figures, businesses, brands, organizations and nonprofits can connect with their fans or customers.
                                    </Typography>
                                </Box>
                            </Box>
                            <Radio value='Page' onChange={handleChange} checked={isSelectedChannelType("Page")} />
                        </Box>

                        <Box
                            onClick={() => updateChanel('Group')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='error' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/ios/32/groups.png" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Facebook Group</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                    A community with your fans and supporters. Gives page owner a platform to build an engaged, relevant among existing and potential customers.
                                    </Typography>
                                </Box>
                            </Box>
                            <Radio value='Group' onChange={handleChange} checked={isSelectedChannelType("Group")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("Google") &&
                    <>
                        <Box
                           onClick={() => updateChanel('YoutubeChannel')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                <img src="	https://img.icons8.com/fluency/32/youtube-play.png" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Youtube Channel</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Channel to connect with your followers and subscribers.
                                    </Typography>
                                </Box>
                            </Box>
                           <Radio value='YoutubeChannel' onChange={handleChange} checked={isSelectedChannelType("YoutubeChannel")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("Pinterest") &&
                    <>
                        <Box
                            onClick={() => updateChanel('PinterestBoard')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/?size=32&id=1481&format=png" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Pinterest Board</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Pin Your Passions: A Platform to Connect, Engage and Share Your Unique Interests with Followers and Subscribers!
                                    </Typography>
                                </Box>
                            </Box>
                            <Radio value='PinterestBoard' onChange={handleChange} checked={isSelectedChannelType("PinterestBoard")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("Instagram") &&
                    <>
                        <Box
                        onClick={() => updateChanel('InstragramBusinessAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/?size=32&id=Xy10Jcu1L2Su&format=png" alt="Instagram Feed" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Instagram Feed</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Share Your Story: Connect and Engage with Your Followers through Beautiful Photos and Captivating Stories!
                                    </Typography>
                                </Box>
                            </Box>
                        <Radio value='InstragramBusinessAccount' onChange={handleChange} checked={isSelectedChannelType("InstragramBusinessAccount")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("TikTok") &&
                    <>
                        <Box
                            onClick={() => updateChanel('TikTokCreatorAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/?size=32&id=118640&format=png" alt="TikTok Creator account" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Creator Account</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Share Your Story: Connect and Engage with Your Followers through Beautiful Photos and Captivating Stories!
                                    </Typography>
                                </Box>
                            </Box>
                            <Radio value='TikTokCreatorAccount' onChange={handleChange} checked={isSelectedChannelType("TikTokCreatorAccount")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("Threads") &&
                    <>
                        <Box
                        onClick={() => updateChanel('ThreadsAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                <img src="https://img.icons8.com/?size=32&id=AS2a6aA9BwK3&format=png&color=000000" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Threads Account</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Channel to connect with your followers and subscribers.
                                    </Typography>
                                </Box>
                            </Box>
                        <Radio value='ThreadsAccount' onChange={handleChange} checked={isSelectedChannelType("ThreadsAccount")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("LinkedIn") &&
                    <>
                        <Box
                            onClick={() => updateChanel('LinkedInAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                <img src="https://img.icons8.com/?size=32&id=13930&format=png&color=000000" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>LinkedIn Account</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Channel to connect with your followers and connections.
                                    </Typography>
                                </Box>
                            </Box>
                        <Radio value='LinkedInAccount' onChange={handleChange} checked={isSelectedChannelType("LinkedInAccount")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("Reddit") &&
                    <>
                        <Box
                            onClick={() => updateChanel('RedditAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                <img src="https://img.icons8.com/?size=32&id=8weyx4k1jpJy&format=png&color=000000" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Reddit Account</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Channel to connect with your followers and connections.
                                    </Typography>
                                </Box>
                            </Box>
                        <Radio value='RedditAccount' onChange={handleChange} checked={isSelectedChannelType("RedditAccount")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("X") &&
                    <>
                        <Box
                            onClick={() => updateChanel('XAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/?size=32&id=phOKFKYpe00C&format=png&color=000000" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>X Account</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Channel to connect with your followers and audience.
                                    </Typography>
                                </Box>
                            </Box>
                            <Radio value='XAccount' onChange={handleChange} checked={isSelectedChannelType("XAccount")} />
                        </Box>
                    </>
                }
                {isSelectedMedium("Discord") &&
                    <>
                        <Box
                            onClick={() => updateChanel('DiscordAccount')}
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    <img src="https://img.icons8.com/?size=32&id=30998&format=png&color=000000" />
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>Discord Account</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        Channel to connect with your followers and subscribers.
                                    </Typography>
                                </Box>
                            </Box>
                            <Radio value='DiscordAccount' onChange={handleChange} checked={isSelectedChannelType("DiscordAccount")} />
                        </Box>
                    </>
                }
            </Box>
        </Box>
    )
}

export default TabChannelTypeSelection
